import Headerimage from "./Headerimage";
import TextBlock1Blue from "./TextBlock1Blue";
import Novel from "./Novel";
import TextBlock2White from "./TextBlock2White";
import TextBlock3Beige from "./TextBlock3Beige";
import TextBlock4White from "./TextBlock4White";
import TextBlock5More from "./TextBlock5More";
import TextBlock7Parallax from "./TextBlock7Parallax";
import Video from "./Video";

const Parts = [
    Headerimage,
    TextBlock1Blue,
    Novel,
    TextBlock2White,
    TextBlock3Beige,
    TextBlock4White,
    TextBlock5More,
    TextBlock7Parallax,
    Video,
];

export {Parts};
